import { defineMessages } from 'react-intl';

export default defineMessages({
    hideDetails: {
        id: 'policy.common.component.cp-coverages-component.hide Details',
        defaultMessage: 'Hide Details'
    },
    showDetails: {
        id: 'policy.common.component.cp-coverages-component.show Details',
        defaultMessage: 'Show Details'
    },
    limit: {
        id: 'policy.common.component.cp-coverages-component.Limit',
        defaultMessage: 'Limit'
    },
    deductible: {
        id: 'policy.common.component.cp-coverages-component.Deductible',
        defaultMessage: 'Deductible'
    },
    coverage: {
        id: 'policy.common.component.cp-coverages-component.Coverage',
        defaultMessage: 'Coverage',
    },
    buildings: {
        id: 'policy.common.component.cp-coverages-component.Buildings',
        defaultMessage: 'Buildings',
    },
    Coverage: {
        id: 'policy.common.component.cp-coverages-component.Coverage',
        defaultMessage: 'Coverage',
    },
    NoBuilding: {
        id: 'policy.common.component.cp-coverages-component.NoBuilding',
        defaultMessage: 'NoBuilding',
    },
    CoveragesEmpty: {
        id: 'policy.common.component.cp-coverages-component.CoveragesEmpty',
        defaultMessage: 'CoveragesEmpty',
    },
    principalOperations: {
        id: 'policy.common.component.cp-coverages-component.Principal Operations / Occupancy:',
        defaultMessage: 'Principal Operations / Occupancy:',
    }

});
